import { render, staticRenderFns } from "./DropdownSubmenu.vue?vue&type=template&id=46897fd5"
import script from "./DropdownSubmenu.vue?vue&type=script&lang=js"
export * from "./DropdownSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports